// @ts-nocheck
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import { Typography } from "@insite/mobius/index";
import getColor from "@insite/mobius/utilities/getColor";
import FadeIn from "@store/Library/Components/Reporting/Common/FadeIn";
import CardIconCircle from "@store/Library/Components/Reporting/LinkCard/CardIconCircle";
import React from "react";
import styled from "styled-components";

export const Card = styled.a`
    border-radius: 0.75rem;
    opacity: 0.9;
    box-shadow: ${({ theme }) => theme.shadows.small};
    &:hover {
        opacity: 1;
        box-shadow: ${({ theme }) => theme.shadows.main};
    }

    padding: 1.5rem;
    border: 1.5px solid ${getColor("common.border")};
    margin-top: 1rem;
    height: 200px;
    width: 280px;
    transition: all 250ms ease-in-out;
`;

const CardHeader = styled.div`
    display: flex;
    justify-content: center !important;
    margin-top: -40px;
    position: relative;

    justify-content: space-between;
    align-items: center;

    height: 25%;
`;
const CardMiddle = styled.div`
    display: flex;
    margin-top: 2rem;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 50%;
`;

const CardFooter = styled.div`
    display: flex;

    justify-content: space-between;
    align-items: center;
    height: 25%;
`;
interface Props {
    color: string;
    linkData: PageLinkModel;
    delay?: number;
}
const LinkCard: React.FC<Props> = ({ color, linkData, delay = 0 }) => {
    const { url, title } = linkData;
    return (
        <FadeIn delay={delay} appear={true} animate={true}>
            <Card href={url}>
                <CardHeader>
                    <CardIconCircle color={color} />
                </CardHeader>
                <CardMiddle>
                    <Typography variant="h4">{title}</Typography>{" "}
                </CardMiddle>
                <CardFooter />
            </Card>
        </FadeIn>
    );
};

export default LinkCard;
